export default "__VITE_ASSET___rOZrKJd__"